import React, { useRef, useState } from "react";
import Sidebar from "./sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./images/recipt _ Logo 1.png";
import sb_image from "./images/socialbenefit_image.png";
import ticket from "./images/ticekt.png";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
function ViewProject() {
  const location = useLocation();
  const veiwData = location.state?.project || {};
  const orderData = location.state?.orders || {};




  const navigate = useNavigate();
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);

  const [recieptPopup, setRecieptPopup] = useState(false);
  const [selectedReciept, setSelectedReciept] = useState([]);


  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleRecipt = (id) => {
    const payment = veiwData.payments.find((p) => p.id === id);
    setSelectedReciept({
      ...payment,
      firstName: payment.firstName,
      lastName: payment.lastName,
      phone: payment.phone,
    });
    setRecieptPopup(true);
  };

  const closePopup = () => {
    setRecieptPopup(false);
  };
  const printRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!printRef.current) return;
    try {
      const style = document.createElement("style");
      style.innerHTML = ``;
      document.head.appendChild(style);
      // Generate canvas
      const canvas = await html2canvas(printRef.current, {
        scale: 4,
        useCORS: true,
        backgroundColor: "#ffffff",
        onclone: (documentClone) => {
          const clonedElement = documentClone.getElementById("printRefId");
          if (clonedElement) {
            clonedElement.style.fontFamily = "Arial, sans-serif";
            clonedElement.style.color = "black";
            clonedElement.style.border = "1px solid #000";
          }
        },
      });

      // Convert canvas to image
      const dataURL = canvas.toDataURL("image/png");

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Receipt.pdf");
      // Remove dynamically added styles after PDF generation
      document.head.removeChild(style);

      setRecieptPopup(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };



  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <i
                onClick={() => navigate("/project")}
                className="fa-solid fa-arrow-left text-xl cursor-pointer"
              ></i>


            </div>
            {recieptPopup && (
              <>
                <div
                  onClick={closePopup}
                  className="fixed inset-0 flex flex-col top-0 left-0 w-screen h-screen z-[9999] items-center justify-center bg-black bg-opacity-50"
                >
                  <button
                    className="bg-[#C65B1D] px-4 py-1 rounded-md text-white mb-2"
                    onClick={handleDownloadPDF}
                  >
                    Downolad PDF
                  </button>
                  <div
                    ref={printRef}
                    className="bg-white border flex flex-col gap-10  shadow-lg  w-[556px] h-[800px]  py-16 px-6 max-w-6xl"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h2 className="text-sm font-semibold">
                          {selectedReciept.firstName} {selectedReciept.lastName}
                        </h2>
                        <p className="text-xs text-[#646464]">
                          GSTIN : <span>{selectedReciept.notes.gst_no}</span>{" "}
                        </p>
                      </div>
                      <div>
                        <img className="w-[100px] h-[20px]" src={logo} alt="" />
                      </div>
                    </div>

                    <div className="text-xs">
                      <p className="text-[#505050]">
                        <span className="text-sm font-medium">
                          Payment Receipt :
                        </span>
                        Transaction Reference :{" "}
                        <span className="text-[#646464]">
                          {selectedReciept.id}
                        </span>{" "}
                      </p>
                      <p className="text-[#646464]">
                        This is a payment receipt for your transaction on
                        Project RenewCred-1
                      </p>
                    </div>

                    <div>
                      <h2 className="text-sm text-[#646464]">
                        AMOUNT PAID:
                        <span className="font-semibold text-sm">
                          ₹{" "}
                          {selectedReciept.amount / 100 -
                            selectedReciept.fee / 100}
                        </span>
                      </h2>
                    </div>

                    <div className="grid grid-cols-2 text-[#646464] text-xs">
                      <div className="leading-5">
                        <p>ISSUED To</p>
                        <p>{selectedReciept.notes.email}</p>
                        <p>{selectedReciept.notes.phone}</p>
                      </div>
                      <div>
                        <p>PAID ON</p>
                        {/* <p>7 Aug 2025</p> */}
                      </div>
                    </div>
                    <div className="">
                      <table className="min-w-[100%] table-auto  shadow-sm border border-separate border-spacing-0">
                        <thead className="bg-[#f0f0f0] font-medium">
                          <tr>
                            <th className="py-1   text-[#646464] whitespace-nowrap   text-xs text-center border-b border-gray-300 ">
                              DESCRIPTION
                            </th>
                            <th className=" py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs text-center border-b border-gray-300">
                              UNIT PRICE
                            </th>
                            <th className="py-1 w-[20px] text-[#646464] whitespace-nowrap   text-xs  text-center border-b border-gray-300">
                              QTY
                            </th>

                            <th className="py-1 w-[40px] text-[#646464] whitespace-nowrap  text-xs  text-center border-b border-gray-300">
                              AMOUNT
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-xs font-normal">
                          <tr>
                            <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                              Carbon Credit Price
                            </td>
                            <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                              {selectedReciept.amount / 100 -
                                selectedReciept.fee / 100}
                            </td>
                            <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                              {(selectedReciept.amount / 100 -
                                selectedReciept.fee / 100) /
                                50}
                            </td>
                            <td className="py-1 border  text-[#5A607F] border-[#E4E7EC] text-center">
                              {selectedReciept.amount / 100 -
                                ((selectedReciept.fee / 100) *
                                  (selectedReciept.amount / 100 -
                                    selectedReciept.fee / 100)) /
                                50}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="flex justify-end space-y-4 text-xs mb-10">
                        {/* Billing Summary Section */}
                        <div className="w-36 p-2 space-y-1">
                          <div className="flex justify-between items-center">
                            <p className="font-medium">Total:</p>
                            <p className="font-normal">
                              {selectedReciept.amount / 100 -
                                ((selectedReciept.fee / 100) *
                                  (selectedReciept.amount / 100 -
                                    selectedReciept.fee / 100)) /
                                50}
                            </p>
                          </div>
                          <div className="flex justify-between items-center">
                            <p className="font-medium text-[#00AC4F]">
                              Amount Paid:
                            </p>
                            <p className="font-normal text-[#00AC4F]">
                              ₹{" "}
                              {selectedReciept.amount / 100 -
                                ((selectedReciept.fee / 100) *
                                  (selectedReciept.amount / 100 -
                                    selectedReciept.fee / 100)) /
                                50}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="border 2xl:mt-10 mt-7 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="flex justify-between">
                <h4 className="font-semibold text-xl">{veiwData.projectid}</h4>
                <div>
                  <img src={ticket} alt="" />
                </div>
              </div>

              <div className="grid grid-cols-3 border-b pb-3">
                <div className="leading-10 col-span-1">
                  <p>Project Id</p>
                  <p>Project Name</p>
                  <p>Methodology</p>
                  <p>Credits Available</p>
                  <p>Credit Price</p>
                  <p>Address</p>
                  <p>State</p>
                  <p>City</p>
                  <p>Pincode</p>
                  <p>Location URL</p>
                  <p>Lat - Long</p>
                </div>
                <div className="leading-10 text-[#757575] col-span-2">
                  <p>{veiwData.projectid}</p>
                  <p>{veiwData.projectname}</p>
                  <p>{veiwData.methodology}</p>
                  <p>{veiwData.credits}</p>
                  <p>{veiwData.price}</p>
                  <p>{veiwData.address}</p>
                  <p>{veiwData.state}</p>
                  <p>{veiwData.city}</p>
                  <p>{veiwData.pincode}</p>
                  <p>{veiwData.locationURL}</p>
                  <p>
                    {veiwData.latitude}-{veiwData.longitude}
                  </p>
                </div>
              </div>
              {/* About the Project */}
              <div className="mt-4 border-b pb-3">
                <h4 className="tet-[#000000] text-base font-medium">
                  About the Project
                </h4>
                <p className="mt-2 text-[#757575] text-sm font-medium">
                  {veiwData.projectDescription}
                </p>
              </div>

              {/* How it works */}
              <div className="mt-4 border-b pb-3">
                <h4 className="text-[#000000] text-base font-medium">
                  How it works?
                </h4>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  {veiwData.howworkdetails.map((data, index) => (
                    <div
                      key={index}
                      className="border border-[#EBEBEB] w-[290px] rounded-xl p-4"
                    >
                      <h5 className="text-[#292D32] text-sm font-semibold">
                        {data.label}
                      </h5>
                      <p className="text-[#757575] text-sm font-medium mt-2">
                        {data.Description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Benefits */}
              <div className="mt-4 border-b pb-3">
                <h4 className="text-[#000000] text-base font-medium">
                  Social Benefits
                </h4>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  {veiwData.socialbenefitdetails.map((data, index) => (
                    <div
                      key={index}
                      className="border border-[#EBEBEB] w-[290px] rounded-xl p-4"
                    >
                      <h5 className="text-[#292D32] text-sm font-semibold">
                        <img src={sb_image} alt="sbimage" />
                      </h5>
                      <p className="text-[#757575] text-sm font-medium mt-2">
                        {data.Description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* key points */}
              <div className="mt-4 border-b pb-3">
                <h4 className="text-[#000000] text-base font-medium">
                  Key Points
                </h4>
                <div className="mt-2">
                  <section className="w-full border-2 border-[#00000014] rounded-t-xl">
                    <div className=" border-b  flex justify-between rounded-t-xl">
                      <h4 className=" p-4 text-[#B5B7C0] text-sm font-medium">
                        {" "}
                        Section
                      </h4>
                      <h4 className="p-4 text-[#B5B7C0] text-sm font-medium">
                        {" "}
                        What it covers
                      </h4>
                    </div>
                    {veiwData.keypointdetails.map((data, index) => (
                      <div
                        key={index}
                        className="flex justify-between px-4 py-2 gap-4 items-center  border-b border-[#00000014]"
                      >
                        <p className="text-[#292D32]  text-start text-sm font-medium">
                          {data.Section}
                        </p>
                        <p className="text-[#292D32]  text-end text-sm font-medium">
                          {data.Description}
                        </p>
                      </div>
                    ))}
                  </section>
                </div>
              </div>
            </div>

            {/* <div className="border 2xl:mt-5 mt-5 f  2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
             
              <div>
                <h3 className="text-md font-medium">Orders</h3>

                <section className="mt-2 overflow-x-auto">
                  <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                    <thead className="bg-[#FCFCFC] rounded-t-lg">
                      <tr className="">
                        <th
                          className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg w-[100px]  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8 border-[#E5E5E5]">
                            Sr no
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Order ID
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2  pl-0 w-[200px] border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Order Date
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Customer Name
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Phone No
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Email
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Transaction ID
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Credits (Tones)
                          </div>
                        </th>
                        <th
                          className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="border-r pr-8  border-[#E5E5E5]">
                            Total Amount
                          </div>
                        </th>

                        <th
                          className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                        >
                          <div className="  border-[#E5E5E5]">Receipt</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-[#FFFFFF]">
                      {orderData.map((payment, index) => {
                        return (
                          <tr key={index}>
                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {index + 1}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.razorpayOrderId}
                            </td>

                            <td className="whitespace-nowrap pl-0  py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.orderdate}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.companyName}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.phone}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.emaiid}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.razorpayPaymentId}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              {payment.credits}
                            </td>
                            <td className="whitespace-nowrap pl-0 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              ₹ {payment.subtotalprice}
                            </td>

                            <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                              <i
                                onClick={() => handleRecipt(payment.id)}
                                className="fa-solid fa-download"
                              ></i>
                            </td>

                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </section>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewProject;
